<template>
    <VueSlickCarousel
        class="o-slider"
        v-bind="settings"
        :class="{ 'margin-bottom': settings.dots }"
        ><slot
    /></VueSlickCarousel>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
export default {
    name: 'OSlider',
    components: { VueSlickCarousel },
    props: {
        settings: {
            type: Object,
            default: () => {}
        }
    }
}
</script>
